import React from 'react'
import About from './Components/About/About'
import Contact from './Components/Contact/Contact'
import Footer from './Components/Footer/Footer'
import Header from './Components/Header/Header'
import Navbar from './Components/Navbar/Navbar'
import Pricing from './Components/Pricing/Pricing'
import Services from './Components/Services.jsx/Services'
import './Style.css'

const Website1 = () => {
  return (
   <>
        <Navbar/>
        <Header/>
        <About/>
        <Services/>
        <Pricing/>
        <Contact/>
        <Footer/>
   </>
  )
}

export default Website1